export default "__VITE_ASSET__b96366ee__"